<template>
  <div id="app">
    <Navbar />
    <Breadcrumb v-show="$route.name !== 'Home'" />
    <router-view class="main-container"/>
    <Footer />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import Breadcrumb from './components/Breadcrumb.vue'
export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    Breadcrumb
  }
}
</script>

<style lang="scss">
html,body {
  margin: 0;
  padding: 0;
  height: 100%;
  background: #063793;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #fff;
  background: #063793;
  height: 100%;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
a {
  all:unset;
}
.main-container {
  min-height: calc(100vh - 110px);
  box-sizing: border-box;
  padding: 0 9vw;
  background: #063793;
}
</style>
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  );
}
</style>    